import { HighlightOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";

interface IProcessProgressEndAdornmentProps {
  onAbort: () => void;
  isAbortVisible: boolean;
}

export const ProcessProgressEndAdornment: FC<
  IProcessProgressEndAdornmentProps
> = ({ isAbortVisible, onAbort }) => {
  if (!isAbortVisible) {
    return null;
  }

  return (
    <IconButton onClick={onAbort} size="small">
      <HighlightOff color="error" sx={{ width: 16, height: 16 }} />
    </IconButton>
  );
};
